export default __webpack_public_path__ + "static/mortgages-fd4b4fb484b5fb75e3e9d9fdc76e1624.png";